<template>
  <div
    class="v-input flex flex-wrap flex-direction-column pt-1"
    :class="className "
    @click="$emit('clickBlock')">
    <span
      v-if="!!label"
      class="ml-3 h8-text">{{ label }}</span>
    <v-row
      class="pl-3 custom-masked-input flex-nowrap"
      :class="{ ' error-input ' : message || error, 'pr-2' : appimage || clearable}"
      no-gutters
      @click="ev => $emit('click', ev)">
      <slot name="prefix"/>
      <masked-input
        ref="input"
        v-model="model_text"
        class="masked-input pl-2"
        :class="{'appimage': appimage, 'prefix ': prefix, 'clearable': clearable, 'disabled': disabled }"
        :disabled="readonly || disabled"
        :mask="mask"
        :placeholder="placeholder"
        :placeholder-char="placeholder_char"
        @click="ev => $emit('click', ev)"
        @input="input"/>
      <slot name="appimage"/>
    </v-row>
    <span
      v-if="message"
      class="h8-text pl-3 secondary__red--text">
      {{ message }}
    </span>
  </div>
</template>
<script>
import { debounce } from 'toolkit/utils/util'

export default {
  name: 'customMaskedInput',
  props: {
    mask: [String, Object],
    // 1 - number      \+\1 (111) 1111-11  |     \+\380 (11) 111 11 11
    // a - letter
    // A - letter, forced to upper case when entered
    // * - alphanumeric
    // # - alphanumeric, forced to upper case when entered
    // + - any character
    placeholder_char: String,
    placeholder: String,
    model: [String, Number],
    className: String,
    label: String,
    readonly: Boolean,
    max: String,
    min: String,
    messages: Array,
    message: String,
    prefix: Boolean,
    appimage: Boolean,
    clearable: Boolean,
    disabled: [ Boolean, String ],
    debounce: Boolean,
    error: {
      type: Boolean
    }
  },
  mounted() {
    if (this.readonly) {
      this.$refs.input.$refs.input.readOnly = true
      this.$refs.input.$refs.input.disabled = false
    }
  },
  computed: {
    model_text: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    }
  },
  methods: {
    clikc(ev) {
      this.$emit('click', ev)
    },
    input(text) {
      if  (this.readonly ) {
        text = this.$refs.input.$refs.input._value
        this.$refs.input.$refs.input.value = text
        this.model_text = text
        return
      }
      if (this.debounce ) {
        this.debounceSearch()
      } else {
        this.$emit('input', text )
      }
    },
    debounceSearch: debounce(function () {
      this.$emit('input', this.model_text )
    }, 250),
  },
  watch: {
    model_text() {
      setTimeout(() => {
        this.$refs.input?.updateToCoreState()
      }, 100)

      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss">
.sFormItem.is-error .custom-masked-input {
  border: 2px solid var(--color-error);
}
.custom-masked-input {
  width: 100%;
  font-size: 14px;
  display: flex;
  align-items: center;
  background: var(--white-color);
  border: 2px solid var(--v-main__green-base);
  border-radius: 31px;
  &.error-input {
    border: 2px solid var(--v-secondary__red-base);
  }
  &, .v-input__slot {
    height: 40px;
    min-height: 40px;
  }
  .v-input__slot {
    padding-top: 10px !important;
    margin: 0;
  }
  .v-messages {
    position: relative;
    top: 10px;
  }

  .masked-input {
    width: inherit;
    &.disabled {
      color: gray;
    }
    // &.appimage, &.prefix, &.clearable  {
    //   max-width: calc( 100% - 30px);
    //   &.appimage, &.prefix, &.clearable {
    //     max-width: calc( 100% - 45px);
    //     &.appimage, &.prefix, &.clearable {
    //       max-width: calc( 100% - 60px);
    //     }
    //   }
    // }
  }
}
</style>
<style lang="scss" scoped>
.ml-3.h8-text.mb-1 {
  white-space: nowrap;
}
</style>
